/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

import { Link } from 'react-router-dom';

function Button(props) {
    if(props.type == "route") {
        if(props.active == false) {
            return (
                <Link className="bg-primary hover:bg-secondary px-11 py-4 text-gray-100 cursor-pointer hover:text-white rounded-xl transition cursor-not-allowed" Style={props.Style}>
                    {props.title}
                </Link>
            )
        } else {
            return (
                <Link to={props.link} className="bg-primary hover:bg-secondary px-11 py-4 text-gray-100 cursor-pointer hover:text-white rounded-xl transition" Style={props.Style}>
                    {props.title}
                </Link>
            )
        }
    } else {
        if(props.active == false) {
            return (
                <a className="bg-primary hover:bg-secondary px-11 py-4 text-gray-100 cursor-pointer hover:text-white rounded-xl transition cursor-not-allowed" Style={props.Style}>
                    {props.title}
                </a>
            )
        } else {
            return (
                <a href={props.link} className="bg-primary hover:bg-secondary px-11 py-4 text-gray-100 cursor-pointer hover:text-white rounded-xl transition" Style={props.Style}>
                    {props.title}
                </a>
            )
        }
    }
}

export default Button